import type { Props } from './FormItem'
import FormItem from './FormItem'

const FormItemPerFlag = (props: Props) => {
  return <FormItem {...props} />
}

export default FormItemPerFlag
